export const GO_LIVE_REQUESTED = "@timeline/GO_LIVE_REQUESTED";
export const GO_LIVE_SUCCESS = "@timeline/GO_LIVE_SUCCESS";

export const TIMELINE_UPDATE_REQUESTED = "@timeline/TIMELINE_UPDATE_REQUESTED";

export const TIMESTAMP_UPDATE_SUCCESS = "@timeline/TIMESTAMP_UPDATE_SUCCESS";

export const SET_LAST_SELECTED_DYNAMIC_INTERVAL = "@timeline/SET_LAST_SELECTED_DYNAMIC_INTERVAL";

export const TIMESTAMP_ADDED_TO_HISTORY = "@timeline/TIMESTAMP_ADDED_TO_HISTORY";
